import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_WEB_PAGINATION_PAGE]: 'Page {pageNumber}',
  [StringId.DV_WEB_PAGINATION_PREVIOUS]: 'Previous Page',
  [StringId.DV_WEB_PAGINATION_NEXT]: 'Next Page'
}